import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {useTranslation} from "react-i18next";
import "./ceiba.scss";
import StepCeibaOne from "./steps/stepCeibaOne";
import StepCeibaTwo from "./steps/stepCeibaTwo";
import StepCeibaThree from "./steps/stepCeibaThree";
import StepCeibaFour from "./steps/stepCeibaFour";
import StepCeibaFive from "./steps/stepCeibaFive";
function CeibaPage(props) {

    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [step, setStep] = useState(1);
    const [avatar, setAvatar] = useState("");

    const goTo = (number) => {

        setStep(number)
    }

    return (
        <>
            {step === 1 &&
                <StepCeibaOne  goTo={goTo}  />
            }
            {step === 2 &&
                <StepCeibaTwo  goTo={goTo}  />
            }
            {step === 3 &&
                <StepCeibaThree  goTo={goTo}  />
            }
            {step === 4 &&
                <StepCeibaFour  goTo={goTo}  />
            }
            {step === 5 &&
                <StepCeibaFive  goTo={goTo}  />
            }

        </>
    )
}

export default withTranslation()(CeibaPage);
